export function isNewlyCreated(value) {
    return Boolean(value && value.length > 4 && value.includes(' "'));
}
